import React from "react";
import { LiveUsers } from "./LiveData";
import { PaywallSettings } from "./PaywallSettings";
export default function Users() { return <><LiveUsers/><div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10"><PaywallSettings/></div></>; }